export default {
  methods: {
    getFlag(flagName)
    {
      try
      {
        return require(`../assets/flags/${flagName.toLowerCase()}.svg`)
      }
      catch (e)
      {
        return require('../assets/flags/undefined.svg')
      }
    }
  }
}
